import { PROFFIT_SEARCH_SEARCH_UNIT_SLIDE } from '../../define/consts/proffit_search/search';
import { replaceWithFormat } from '../common/StringHelper';
/**
 * スライドサーチフィルターボタン用のフォーマット
 * @param str 対象の文字列
 * @returns 改行置換済み文字列
 */
const filterButtonFormat = (str) => replaceWithFormat(str, 6, [
    {
        pattern: /・/g,
        string: '・\n',
    },
    {
        pattern: /（/g,
        string: '\n（',
    },
]);
/**
 * 画面選択中のunitに応じたリクエスト用のキーの取得
 * @param unitValue
 * @returns {string}
 */
const getRequestKeyFromUnitValue = (unitValue) => {
    if (unitValue === PROFFIT_SEARCH_SEARCH_UNIT_SLIDE.value) {
        return 'slideSearchSlidePageUuid';
    }
    return 'slideSearchSlideUuid';
};
/**
 * 画面選択中に応じた使用するレスポンス用のキーの取得
 * @param unitValue
 * @returns {string}
 */
const getResponseKeyFromUnitValue = (unitValue) => {
    if (unitValue === PROFFIT_SEARCH_SEARCH_UNIT_SLIDE.value) {
        return 'pageId';
    }
    return 'slideId';
};
/**
 * 画面選択中に応じた使用するリクエスト用の値をスライドから取得
 * @param slide
 * @param unitValue
 * @returns {string}
 */
const getSlideRequestKeyFromUnitValue = (slide, unitValue) => slide[getRequestKeyFromUnitValue(unitValue)];
/**
 * 画面選択中に応じた使用するレスポンス用の値をスライドから取得
 * @param slide
 * @param unitValue
 * @returns {string}
 */
const getSlideResponseKeyFromUnitValue = (slide, unitValue) => slide[getResponseKeyFromUnitValue(unitValue)];
export const slideSearchPageHelper = {
    filterButtonFormat,
    getRequestKeyFromUnitValue,
    getResponseKeyFromUnitValue,
    getSlideRequestKeyFromUnitValue,
    getSlideResponseKeyFromUnitValue,
};
export default slideSearchPageHelper;
